(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.setupMobileDrawer();
      this.setupDesktopDetails();
      this.setupCartDrawer();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    setupMobileDrawer() {
      const drawer = this.querySelector('[data-hvb-mobile-menu]');
      if (!drawer) return;

      this.querySelectorAll('[data-hvb-close]').forEach((close) => {
        close.addEventListener('click', () => {
          drawer.removeAttribute('open');
        });
      });

      drawer.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          drawer.removeAttribute('open');
        });
      });

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') drawer.removeAttribute('open');
      });
    }

    setupDesktopDetails() {
      const details = this.querySelectorAll('.hvb-nav details');
      details.forEach((detail) => {
        detail.addEventListener('mouseenter', () => {
          details.forEach((other) => {
            if (other !== detail) other.removeAttribute('open');
          });
          detail.setAttribute('open', '');
        });

        detail.addEventListener('mouseleave', () => {
          detail.removeAttribute('open');
        });
      });

      document.addEventListener('click', (event) => {
        details.forEach((detail) => {
          if (!detail.contains(event.target)) detail.removeAttribute('open');
        });
      });
    }

    setupCartDrawer() {
      const cartLink = this.querySelector('#cart-icon-bubble');
      if (!cartLink || this.dataset.cartType !== 'drawer') return;

      cartLink.addEventListener('click', (event) => {
        const cartDrawer = document.querySelector('cart-drawer');
        const drawerEl = document.getElementById('CartDrawer') || document.querySelector('.cart-drawer');

        if (!cartDrawer && !drawerEl) return;

        event.preventDefault();

        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(cartLink);
          return;
        }

        if (drawerEl) {
          drawerEl.classList.add('active', 'animate');
          document.body.classList.add('overflow-hidden');
          drawerEl.removeAttribute('hidden');
          const drawerDialog = drawerEl.querySelector('[role="dialog"]') || drawerEl;
          if (drawerDialog && drawerDialog.focus) drawerDialog.focus();
        }
      });
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.querySelectorAll('.hvb-nav details, [data-hvb-mobile-menu]').forEach((detail) => detail.removeAttribute('open'));
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.close) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
